import React, { useEffect } from 'react'
import '../css/lead-magnet-style.css'
import { Link, useLocation } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux';
import { setCountry } from '../redux/slices/countrySlice';
import ActionButton from '../components/ActionButton';
import TrustedPartner from '../components/trustedPartners/TrustedPartner';

const LeadMaget = () => {

    const location = useLocation();
    const dispatch = useDispatch();

    const allowedCountries = ["us", "ksa", "au", "uae"];
    const currentCountryFromUrl = allowedCountries.find((country) =>
        location.pathname.includes(`/${country}`)
    );

    const country = useSelector((state) => state.country.name);

    const currentCountry = currentCountryFromUrl
        ? currentCountryFromUrl
        : country;

    useEffect(() => {
        if (currentCountryFromUrl) {
            console.log(`check ${currentCountryFromUrl}`);
            dispatch(setCountry(country));
        }
    }, []);

    // DOWNLOAD PDF
    const handleDownloadPdf = (e) => {
        e.preventDefault();
    }

    // CLINET LOGO BOXES
    const clientLogos = [
        "/images/client-logo/client-logo1.png",
        "/images/client-logo/client-logo2.png",
        "/images/client-logo/client-logo3.png",
        "/images/client-logo/client-logo4.png",
        "/images/client-logo/client-logo5.png",
        "/images/client-logo/client-logo6.png",
        "/images/client-logo/client-logo7.png",
        "/images/client-logo/client-logo8.png",
        "/images/client-logo/client-logo9.png",
        "/images/client-logo/client-logo10.png",
        "/images/client-logo/client-logo11.png",
        "/images/client-logo/client-logo12.png",
        "/images/client-logo/client-logo13.png",
        "/images/client-logo/client-logo14.png",
        "/images/client-logo/client-logo15.png",
    ];


    return (
        <>
            {/* HEADER */}
            <nav className='lead-magnet-page-logo'>
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 justify-content-center d-flex"><Link to='/'><img src="/images/logo.svg" width={210} alt="Bitsclan Logo" /></Link></div>
                    </div>
                </div>
            </nav>

            {/* BANNER ISSUES */}
            <div className="lead-magnet-banner-box">
                <div className="container px-5">
                    <div className="row">
                        <div className="col-xl-7">
                            <div className="lead-magnet-banner-text">
                                <h1 className="lead-magnet-main-heading">Avoid the #1 Mistake SaaS Founders Make When Hiring <span>Python Devs</span> Download This 1-Page Screening Guide</h1>
                                <p className="lead-magnet-description">In Less Than 5 Minutes, You'll Know Exactly Who to Interview & Who'll Just Slow Down Your Team</p>

                                <ActionButton text='Download the Free 1 -page Checklist Now' onClick={handleDownloadPdf} />
                            </div>
                        </div>

                        <div className="col-xl-5">
                            <div className="lead-magnet-banner-image">
                                <img src="/images/engagment-model-images/engagment-scroll-image4.png" alt="" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* TRUSTED LOGO SECTION */}
            <div className="grey-bg-box">
                <div className="container px-5">
                    <div className="row">
                        <div className="col-md-12">
                            <h1 className="trusted-main-heading">We're Trusted By:</h1>
                        </div>
                    </div>
                </div>
            </div>
            <div className="trusted-partners-main-box">
                <div className="container px-5">
                    <div className="row mt-3">
                        <div className="col-md-12">
                            <div className="client-logo-slider-wrapper overflow-hidden mt-3">
                                <div className="client-logo-slider-box flex animate-scroll">
                                    {clientLogos?.concat(clientLogos)?.map((logo, index) => (
                                        <img
                                            key={index}
                                            className="trusted-logo-images"
                                            src={logo}
                                            alt={`Client Logo ${index + 1}`}
                                        />
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* CONTENT BOX */}
            <div className="lead-magnet-text-box-main">
                <div className="container px-5">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="lead-magnet-section">
                                <h2 className="lead-magnet-heading">
                                    Attention <span>SaaS Founders</span> & Tech Leads:
                                </h2>
                                <p className="lead-magnet-description">
                                    <span className="lead-magnet-bold">Hiring the wrong Python developer won’t just cost you money…</span><br />
                                    It’ll cost you deadlines. Morale. Clients.
                                    & in some cases your shot at that next funding round.
                                </p>
                                <p className="lead-magnet-description">
                                    Why? <br />
                                    Because most Python devs know <span className="lead-magnet-bold">how to talk about code…</span>
                                    but fall apart the moment they’re asked to ship it in production.
                                </p>
                                <p className="lead-magnet-description">You know the type:</p>
                                <ul className="lead-magnet-checklist">
                                    <li className="lead-magnet-check">Big claims on the resume</li>
                                    <li className="lead-magnet-check">Smooth answers in the interview</li>
                                    <li className="lead-magnet-cross">Confused by ORM performance issues</li>
                                    <li className="lead-magnet-cross">Break things in staging</li>
                                    <li className="lead-magnet-cross">Deliver half the speed you expected</li>
                                </ul>
                                <p className="lead-magnet-sub-heading">That’s why we created this.</p>
                                <p className="lead-magnet-highlight">✔ The Python Developer Vetting Checklist</p>
                                <p className="lead-magnet-description">
                                    It’s a fast, no-fluff, battle-tested screening tool you can use to:
                                </p>
                                <ul className="lead-magnet-points">
                                    <li>Quickly filter out underqualified devs before wasting an interview slot</li>
                                    <li>Spot red flags that <span className="lead-magnet-highlight">don’t show up in resumes</span></li>
                                    <li>Understand what a <span className="lead-magnet-highlight">real production-ready Python dev</span> looks like</li>
                                </ul>
                                <ul className="lead-magnet-checklist">
                                    <li className="lead-magnet-check">Takes less than 5 minutes to read</li>
                                    <li className="lead-magnet-check">Built for SaaS teams hiring Python, Django, or FastAPI</li>
                                    <li className="lead-magnet-check">Based on real-world experience not theory</li>
                                </ul>
                                <p className="lead-magnet-description">
                                    If you’re serious about moving fast & hiring right the first time…
                                </p>

                                <ActionButton text='Download the Free 1 -page Checklist Now' onClick={handleDownloadPdf} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* FOOTER */}
            <footer className='kead-maangement-footer-logo-box'>
                <div className="container px-5">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="lead-management-footer-box-main">
                                <div className="lead-management-footer-logo d-flex justify-content-center">
                                    <img src="/images/white-logo.svg" width={190} alt="" />
                                </div>
                            </div>
                        </div>

                        <div className="row border-top-footer">
                            <div className="col-md-12">
                                <div className="copyright-box-main">
                                    <p>© 2025 All Rights Reserved.</p>
                                    <ul className="footer-list copyright-links-text">
                                        <li><Link to='/privacy-policy'>Privacy Policy</Link></li>
                                        <li><Link to='/terms-and-conditions'>Terms & conditions</Link></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        </>
    )
}

export default LeadMaget